<template>
  <div class="course-main">
    <div class="course-info">
      <div class="location">
        <div class="buy-now" v-if="myOpacity> 0.5" :style="{opacity: myOpacity}">
          <template v-if="courseInfo.preferentialPrice || courseInfo.preferentialPrice === 0">
            {{ courseInfo.preferentialPrice === 0 ? '免费' : '￥' + courseInfo.preferentialPrice + '元' }}
          </template>
          <template v-else>
            {{ courseInfo.originPrice ? '￥' + courseInfo.originPrice + '元' : '免费' }}
          </template>
          <div class="buy-now-button" @click="buyNow">立即购买</div>
        </div>
        <img :src="require('../../assets/img/location.png')" alt="">
        当前位置：
        <template v-for="(item, index) in pathList">
          <span :key="index" class="location-name" @click="$router.push(item.path)">{{ item.name }}  </span> >
        </template>
        专题详情
      </div>
      <div class="course-content">
        <div class="course-content-title">{{ courseInfo.specialTitle }}</div>
        <span class="course-content-time">发布时间：{{ courseInfo.inputTime }} </span>
        <span class="course-content-price">
          <template v-if="courseInfo.preferentialPrice || courseInfo.preferentialPrice === 0">
            {{ courseInfo.preferentialPrice === 0 ? '免费' : '￥' + courseInfo.preferentialPrice + '元' }}
          </template>
          <template v-else>
            {{ courseInfo.originPrice ? '￥' + courseInfo.originPrice + '元' : '免费' }}
          </template>
        </span>
        <div class="buy-now-button" @click="buyNow">立即购买</div>
        <div class="course-content-collected" :style="{color: isCollected === 'confirm' ? '#EA5504' : '#999999'}" @click="collect"><i class="el-icon-star-on" style="font-size: 25px;vertical-align: middle" />收藏</div>
        <img v-if="courseInfo.coverImg" :src="$urlPrefix + courseInfo.coverImg" alt="">
        <div v-else class="course-cover">
          <p>{{ courseInfo.specialTitle }}</p>
        </div>
      </div>
      <div class="section">
        <div class="section-title">
          课程介绍
          <div class="bar" />
        </div>
        <div style="width: 1160px;background-color:#FFFFFF;padding: 20px;margin: 0 auto;text-align: initial" v-html="courseInfo.specialContent"></div>
      </div>
      <div class="section" v-if="tutorList && tutorList.length > 0">
        <div class="section-title">
          导师阵容
          <div class="bar" />
        </div>
        <div class="tutor">
          <div v-for="(item, index) in tutorList" :key="index" class="content-item" :class="{marginLeft: index !== 0}">
            <img :src="item.headImg ? $urlPrefix + item.headImg : require('../../assets/img/defaultHead2.png')" alt="">
            <span @click="checkTutor(item.pkid)">{{ item.tutorName }}</span>
            <div class="tutor-details">{{ item.tutorProfile }}</div>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="section-title">
          课程列表
          <div class="bar" />
        </div>
        <div v-for="(item, index) in courseList" :key="index" class="course-item">
          <img v-if="item.coverImg" :src="$urlPrefix + item.coverImg" alt="">
          <div v-else class="coverArea">
            <p>{{ item.courseTitle }}</p>
          </div>
          <div class="title" @click="checkCourse(item.pkid)">{{ item.courseTitle }}</div>
          <div class="detail">&nbsp;&nbsp;{{ item.detail }}</div>
          <span class="speaker">主讲人：{{ item.keynoteSpeaker ? item.keynoteSpeaker : '暂无' }}</span>
          <span class="time">发布时间：{{ item.inputTime }}</span>
          <div class="check-detail" @click="checkCourse(item.pkid)">查看详情</div>
        </div>
        <div v-if="courseTotal !== courseList.length" class="lading-more" @click="getCourse()">
          <template v-if="loading">
            <i class="el-icon-loading"></i>
            加载中...
          </template>
          <template v-else>
            ·&nbsp;·&nbsp;·&nbsp;点击加载更多&nbsp;·&nbsp;·&nbsp;·
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'CourseMain',
  data() {
    return {
      pathList: [],
      currentPathList: [],
      courseTotal: 'a',
      pageNumber: 0,
      isCollected: false,
      myOpacity: '0',
      showBuy: false,
      loading: false,
      courseList: [],
      tutorList: [],
      fromPath: {
        name: '',
        path: ''
      },
      courseInfo: {}
    }
  },
  computed: {
    ...mapState(['token'])
  },
  created() {
    if (this.$route.query.pathList) {
      this.pathList = JSON.parse(this.$route.query.pathList)
      this.pathList = this.pathList.filter(item => item.name !== '专题详情')
      this.currentPathList = JSON.stringify([...this.pathList, {
        name: '专题详情',
        path: this.$route.fullPath
      }])
    }
    if (this.token) {
      this.getCollectStatus()
    }
    this.getCourse()
    this.fetchData()
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    fetchData() {
      this.$get('/front/index/specialCourseInfo', this.$route.query.pkid).then(res => {
        if (res) {
          this.courseInfo = res
          this.tutorList = res.tutorList
        }
      })
    },
    getCourse() {
      const params = {
        pageNumber: this.pageNumber += 1,
        pageSize: 5,
        specialPkid: this.$route.query.pkid
      }
      this.loading = true
      this.$post('/front/index/coursePage', params).then(res => {
        if (res) {
          this.courseTotal = res.total
          this.courseList = [...this.courseList, ...res.records]
        }
        this.loading = false
      })
    },
    getCollectStatus() {
      const param = {
        sourcePkid: this.$route.query.pkid,
        collectType: 'specialCourse'
      }
      this.$post('/front/index/collectStatus', param).then(res => {
        this.isCollected = res
      })
    },
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 300) {
        scrollTop < 400 ? this.myOpacity = (scrollTop - 300) / 100 : this.myOpacity = 1
      } else {
        this.myOpacity = 0
      }
    },
    checkCourse(pkid) {
      this.$router.push({
        path: '/courseDetail',
        query: {
          pkid: pkid,
          pathList: this.currentPathList
        }
      })
    },
    checkTutor(pkid) {
      this.$router.push({
        path: '/tutorDetail',
        query: {
          pkid: pkid,
          pathList: this.currentPathList
        }
      })
    },
    buyNow() {
      window.open(this.courseInfo.skipLink, '_blank')
    },
    collect() {
      if (!this.token) {
        return this.$message.warning('请先登录 !')
      }
      let text
      this.isCollected === 'confirm' ? text = '确定取消收藏该专题课程 ?' : text = '确定收藏该专题课程 ?'
      this.$confirm(text, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const param = {
          sourcePkid: this.$route.query.pkid,
          collectType: 'specialCourse',
          action: this.isCollected === 'confirm' ? 'cancel' : 'confirm'
        }
        this.$post('/front/index/collect', param).then(res => {
          if (res) {
            this.isCollected = this.isCollected === 'confirm' ? 'cancel' : 'confirm'
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.course-main {
  background-color: #F6F6F5;
  padding-top: 25px;

  .course-info {
    .location {
      width: 1200px;
      font-size: 14px;
      font-weight: 400;
      color: #363942;
      margin: 0 auto 35px auto;
      .buy-now {
        width: 1160px;
        height: 100px;
        padding: 0 20px;
        line-height: 100px;
        background: #FFFFFF;
        box-shadow: 0 0 10px 0 rgba(51, 51, 51, 0.2);
        border-radius: 5px;
        margin: 0 auto;
        position: fixed;
        top: 0;
        z-index: 999;
        font-size: 36px;
        font-weight: bold;
        color: #FE383B;
        .buy-now-button {
          width: 160px;
          height: 50px;
          float: right;
          margin-top: 25px;
          line-height: 50px;
          background: #EA5504;
          border-radius: 5px;
          font-size: 24px;
          font-weight: 400;
          color: #FFFFFF;
          text-align: center;
          cursor: pointer;
        }
        .buy-now-button:hover {
          opacity: 0.8;
        }
      }

      img {
        vertical-align: middle;
        margin-right: 10px;
      }

      .location-name {
        cursor: pointer;
        color: darkgray;
      }

      .location-name:hover {
        color: #EA5504;
      }
    }

    .course-content {
      position: relative;
      width: 1200px;
      height: 200px;
      background: #FFFFFF;
      border-radius: 5px;
      margin: 0 auto;

      img {
        position: absolute;
        right: 0;
        top: 0;
        width: 800px;
        height: 200px;
        border-radius: 0 5px 5px 0;
        float: right;
      }
      .course-cover {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        right: 0;
        top: 0;
        width: 800px;
        height: 200px;
        border-radius: 0 5px 5px 0;
        background: url("../../assets/img/activeCover.png") no-repeat;
        background-size: 100% 100%;
        font-size: 22px;
        box-sizing: border-box;
        padding: 20px 80px;
        line-height: 35px;
        color: #FFFFFF;
        text-align: center;
        p {
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-all;
          display: -webkit-box; // 作为弹性伸缩盒子模型显示。
          -webkit-box-orient: vertical; // 设置伸缩盒子的子元素排列方式--从上到下垂直排列
          -webkit-line-clamp: 2; // 显示的行
        }
      }
      .course-content-title {
        position: absolute;
        left: 0;
        top: 20px;
        width: 400px;
        padding: 0 30px;
        height: 60px;
        line-height: 60px;
        background: #EA5504;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 24px;
        font-weight: 400;
        color: #FFFFFF;
        z-index: 20;
      }
      .course-content-time {
        position: absolute;
        left: 30px;
        top: 90px;
        font-size: 14px;
        font-weight: 400;
        color: #363942;
      }
      .course-content-price {
        position: absolute;
        left: 30px;
        bottom: 20px;
        font-size: 24px;
        font-weight: bold;
        color: #E21313;
      }
      .buy-now-button {
        position: absolute;
        left: 230px;
        bottom: 20px;
        width: 80px;
        height: 30px;
        border-radius: 3px;
        margin-left: 10px;
        line-height: 30px;
        text-align: center;
        font-size: 14px;
        color: #FFFFFF;
        background-color: #EA5504;
        vertical-align: top;
        cursor: pointer;
      }
      .buy-now-button:hover {
        opacity: 0.8;
      }

      .course-content-collected {
        position: absolute;
        left: 330px;
        bottom: 23px;
        font-size: 14px;
        font-weight: bold;
        color: #999999;
        cursor: pointer;
        i {
          margin-top: -3px;
        }
      }
    }
    .section {
      padding: 30px 0;
      background-color: #F6F6F6;
      margin: 0 auto;

      .section-title {
        width: 100%;
        height: 78px;
        font-size: 48px;
        font-weight: 400;
        color: #333333;
        line-height: 48px;
        text-align: center;
      }

      .bar {
        width: 40px;
        height: 3px;
        background: #EA5504;
        margin: 15px auto 0 auto;
      }

      .tutor {
        width: 1200px;
        height: 363px;
        margin: 30px auto 0 auto;
        text-align: center;
        .content-item {
          display: inline-block;
          width: 218px;
          height: 363px;
          background: #ffffff;
          border-radius: 5px;
          img {
            width: 218px;
            height: 218px;
            margin-bottom: 15px;
          }
          span {
            font-size: 24px;
            font-weight: bold;
            color: #333333;
            cursor: pointer;
          }
          span:hover {
            color: #EA5504;
          }
          p {
            padding: 10px 5px;
            font-size: 16px;
            font-weight: 400;
            color: #999999;
          }
          .tutor-details {
            width: 218px;
            height: 85px;
            margin-top: 5px;
            padding: 0 10px;
            box-sizing: border-box;
            font-size: 16px;
            font-weight: 400;
            color: #999999;
            overflow: hidden;
            text-align: left;
          }
        }
        .content-item:hover {
          box-shadow: 0 5px 8px 0 rgba(51, 51, 51, 0.1);
        }
        .marginLeft {
          margin-left: 27px;
        }
      }
      .course-item {
        position: relative;
        width: 1200px;
        height: 180px;
        padding: 15px 20px;
        background: #FFFFFF;
        box-shadow: 0 5px 8px 0 rgba(51, 51, 51, 0.1);
        border-radius: 5px;
        box-sizing: border-box;
        margin: 0 auto 20px auto;
        overflow: hidden;
        img {
          display: inline-block;
          width: 210px;
          height: 150px;
          border-radius: 5px;
          vertical-align: top;
        }
        .title {
          display: inline-block;
          width: 920px;
          height: 30px;
          line-height: 30px;
          margin-left: 30px;
          font-size: 18px;
          font-weight: bold;
          color: #333333;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          cursor: pointer;
        }
        .title:hover {
          color: #EA5504;
        }
        .detail {
          position: absolute;
          top: 60px;
          left: 260px;
          width: 780px;
          height: 48px;
          font-size: 16px;
          font-weight: 400;
          color: #333333;
          line-height: 24px;
          overflow: hidden;
          text-overflow: ellipsis ;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          word-break: break-all;
        }
        span {
          position: absolute;
          left: 260px;
          font-size: 14px;
          font-weight: 400;
          color: #666666;
        }
        .speaker {
          top: 120px;
        }
        .time {
          top: 148px;
        }
        .check-detail {
          position: absolute;
          right: 20px;
          top: 75px;
          width: 108px;
          height: 30px;
          line-height: 30px;
          background: #EA5504;
          border-radius: 2px;
          text-align: center;
          font-size: 14px;
          color: #FFFFFF;
          cursor: pointer;
        }
        .check-detail:hover {
          opacity: 0.8;
        }
      }
      .lading-more {
        width: 600px;
        height: 40px;
        line-height: 40px;
        background: #EA5504;
        border-radius: 5px;
        text-align: center;
        color: #FFFFFF;
        margin: 10px auto 0 auto;
        cursor: pointer;
        overflow: hidden;
      }
      .lading-more:hover {
        opacity: 0.8;
      }
    }
  }
}
</style>
